import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TokenService } from './token.service';

@Injectable({
  providedIn: 'root'
})
export class LogService {

  constructor(private http: HttpClient, private tokenService : TokenService) { }


  recupererLog(dateDebut, dateFin){
    let httpHeaders = this.tokenService.loadToken();
    let request = `/api/logs?debut=${dateDebut}&fin=${dateFin}`;
    return this.http.get(request, {headers: httpHeaders});
  }
}
